import React from 'react';
import { useSelector } from 'react-redux';
import { TripState } from '../../types/trip.store.type';
import './UnitPanel.scss';
import { TranslationUtils } from '../../utils';

export const UnitPanel: React.FC = () => {
    const unit = useSelector((store: { trip: TripState }) => store.trip.unit);

    if (!unit) {
        return null;
    }

    const { name, city, state, country_code, photos, unit_link } = unit;

    const imageUrl = photos.length > 0 ? photos[0].url : null;

    const address = `${city}, ${state}, ${country_code}`.toUpperCase();
    return (
        <div className="unit-panel">
            <div>
                <img src={`${imageUrl?.startsWith('https') ? '' : 'https:'}${imageUrl}?w=240`} className="img-thumbnail" alt="" />
            </div>
            <div className="unit-info">
                <span tabIndex={0} aria-label={`${address} ${name}`} className="heading-caps-small-light  unit-address">
                    {address}
                </span>
                <h5 className="heading-xs unit-name">{name}</h5>
                <a className="body-regular" tabIndex={0} target="_blank" rel="noopener noreferrer" href={unit_link}>
                    {TranslationUtils.get('view_listing')}
                </a>
            </div>
        </div>
    );
};
